import { createSlice } from "@reduxjs/toolkit";
import { errorHandler } from "../../../helpers/errorHandler";
import {
    Call,
    CallWithFormDataFile,
    downloadBlob,
} from "../../../helpers/fetch";
import {
    startUILoading,
    stopUILoading,
} from "../../actions/administrador/ui/ui";

const initialState = {
    report: null,
};

export const IncomesByMonth = createSlice({
    name: "IncomesByMonth",
    initialState,
    reducers: {
        setReport: (state, action) => {
            state.report = action.payload;
        },
        clearReport: (state) => {
            state.report = initialState.report;
        },
    },
});

export const { setReport, clearReport } = IncomesByMonth.actions;

export default IncomesByMonth.reducer;

// Actions
export const startShow = ({
    months,
    year,
    concept_id,
    status,
    curricula,
}) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const join_months = months?.map((m) => m?.value)?.join(",");
        const join_concept_id = concept_id?.map((cid) => cid?.value)?.join(",");
        const join_status = status?.map((s) => s?.value)?.join(",");
        const join_curricula = curricula?.map((c) => c?.value)?.join(",");

        const params = new URLSearchParams();
        params.set("months", join_months);
        params.set("year", year);

        if (join_concept_id) {
            params.set("concept_id", join_concept_id);
        }
        if (join_status) {
            params.set("status", join_status);
        }
        if (join_curricula) {
            params.set("curricula", join_curricula);
        }

        const resp = await Call(
            `operators/reports/incomes/per-month`,
            "GET",
            params
        );

        if (resp.success) {
            dispatch(setReport(resp.success));
        } else {
            errorHandler(resp);
        }
        dispatch(stopUILoading());
    };
};

export const startExportReport = ({
    cycles,
    months,
    concept_id,
    status,
    curricula,
}) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const cycles_data = cycles
            .map((cycle) => `${cycle.year}-${cycle.sub_cycle}`)
            ?.join(",");
        const join_months = months?.map((m) => m?.value)?.join(",");
        const join_concept_id = concept_id?.map((cid) => cid?.value)?.join(",");
        const join_status = status?.map((s) => s?.value)?.join(",");
        const join_curricula = curricula?.map((c) => c?.value)?.join(",");

        const params = new URLSearchParams();

        params.set("export", 1);
        params.set("cycles", cycles_data);
        params.set("months", join_months);

        if (join_concept_id) {
            params.set("concept_id", join_concept_id);
        }
        if (join_status) {
            params.set("status", join_status);
        }
        if (join_curricula) {
            params.set("curricula", join_curricula);
        }

        const response = await CallWithFormDataFile(
            `operators/reports/academic-records/debts`,
            "GET",
            params.toString()
        );
        downloadBlob(response, "Reporte de adeudos");

        dispatch(stopUILoading());
    };
};
